module.exports = __webpack_public_path__ + "static/media/BasicPremiumLogo.eaccb8a1.svg";